import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import IProductCategory from '../../../app/_interfaces/IProductCategory';

@Injectable({
  providedIn: 'root',
})
export class ProductsCategoriesService {
  constructor(private http: HttpClient) {}

  getByCustomer(customers_id: number) {
    return this.http.get<IProductCategory[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/products-categories`,
      {}
    );
  }

  update(
    customers_id: number,
    products_categories_id: number,
    productCategory: IProductCategory
  ) {
    return this.http.patch(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/products-categories/${products_categories_id}`,
      productCategory
    );
  }

  create(customers_id: number, productCategory: IProductCategory) {
    return this.http.post(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/products-categories`,
      productCategory
    );
  }

  delete(customers_id: number, products_categories_id: number) {
    return this.http.delete(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/products-categories/${products_categories_id}`,
      {}
    );
  }
}
